//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';

import SolicitudManager from '../../../Common/Managers/SolicitudManager';
import ProcessManager from "../../../Common/Managers/ProcessManager";
import logHelper from 'com-gyf-webcore-loghelper/Content/App/Packages/LogHelper/LogHelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

// ACTION TYPES

export const GET_SCREEN_DATA_ADICIONAL = "GET_SCREEN_DATA_ADICIONAL";
export const ON_BLUR_TEXTBOX = "ON_BLUR_TEXTBOX";
export const SELECT_CHECKBOX_SOLICITUD_ADICIONAL = "SELECT_CHECKBOX_SOLICITUD_ADICIONAL";
export const SELECT_COMBO_SOLICITUD_ADICIONAL = "SELECT_COMBO_SOLICITUD_ADICIONAL";
export const CHANGE_INPUT_N_S_ADICIONAL = "CHANGE_INPUT_N_S_ADICIONAL";
export const VALIDATE_ADICIONAL_ERROR = "VALIDATE_ADICIONAL_ERROR";
export const SHOW_POP_UP_CANCEL_ADICIONAL = "SHOW_POP_UP_CANCEL_ADICIONAL";
export const REDIRECT_VISTA_CLIENTE_FROM_ADICIONAL = "REDIRECT_VISTA_CLIENTE_FROM_ADICIONAL";
export const STOP_REDIRECT_VISTA_CLIENTE_FROM_ADICIONAL = "STOP_REDIRECT_VISTA_CLIENTE_FROM_ADICIONAL";
export const READY_REQUEST_ADICIONAL = "READY_REQUEST_ADICIONAL";
export const SHOW_SAVE_STATUS_NUEVA_SOLICITUD_CUENTA_ADICIONAL = "SHOW_SAVE_STATUS_NUEVA_SOLICITUD_CUENTA_ADICIONAL";
export const GUARDAR_CLIENTE_ADICIONAL = "GUARDAR_CLIENTE_ADICIONAL";
export const GUARDAR_SOLICITUD_CUENTA_ADICIONAL = "GUARDAR_SOLICITUD_CUENTA_ADICIONAL";
export const SHOW_DATOS_CLIENTE="SHOW_DATOS_CLIENTE";
export const EDITAR_CLIENTE_ADICIONAL = "EDITAR_CLIENTE_ADICIONAL";
export const ESCONDER_POPUP_ADICIONAL = "ESCONDER_POPUP_ADICIONAL";
export const ELIMINAR_CLIENTE_ADICIONAL = "ELIMINAR_CLIENTE_ADICIONAL";
export const MOSTRAR_DATOS_TITULAR = "MOSTRAR_DATOS_TITULAR";
export const ROUTE_TO_VISTACLIENTE_FROM_ADICIONAL = "ROUTE_TO_VISTACLIENTE_FROM_ADICIONAL";
export const VOLVER_A_SOLICITUD = "VOLVER_A_SOLICITUD"; // PASA A TRUE FLAG QUE LE INDICA A "NUEVASOLICITUDCUENTA" QUE RECUPERE LOS DATOS DESDE TARJETA
export const ROUTE_TO_CUENTA_FROM_ADICIONAL = 'ROUTE_TO_CUENTA_FROM_ADICIONAL';
export const CLEAN_STORE = 'CLEAN_STORE';
export const CANCELAR_ADICIONAL = 'CANCELAR_ADICIONAL';
export const CONFIRMAR_CLIENTE_PARA_TARJETA_ADICIONAL = 'CONFIRMAR_CLIENTE_PARA_TARJETA_ADICIONAL';
export const CARGAR_CLIENTE_PARA_TARJETA = 'CARGAR_CLIENTE_PARA_TARJETA';
export const ELIMINAR_CLIENTE_ADICIONAL_TARJETAS = 'ELIMINAR_CLIENTE_ADICIONAL_TARJETAS';
export const READY_REQUEST_CUENTA_ADIC = 'READY_REQUEST_CUENTA_ADIC';

/*variables a validar*/
let _dispatch, _tarjetas, _tipoEmpresa = null;
let userFeatures = [];
let _executionContext;

/**
 * 
 * @param {any} currentScope
 */
export function getScreenData(state, currentScope) {
    LogHelper.In(getScreenData.name, state, currentScope);

    return (dispatch, getState) => {
        _tarjetas = JSON.parse(JSON.stringify(getState().tarjetas));
        _dispatch = dispatch;
        //    _tipoEmpresa = JSON.parse(JSON.stringify(getState().nuevaSolicitudTipoEmpresa.tipoEmpresaSeleccionada));
        _executionContext = JSON.parse(JSON.stringify(getState().sesion.executionContext));

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }
        ConciergeProxy.Execute((data) => _cargarDatosPantalla(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

export function onBlurTextBox(action, value) {
    LogHelper.In(onBlurTextBox.name, action, value);

    return (dispatch) => {
        dispatch({ type: ON_BLUR_TEXTBOX, action: action, value: value });
    }
}

export function selectCheckBox(action) {
    LogHelper.In(selectCheckBox.name, action);
    return (dispatch) => {
        dispatch({ type: SELECT_CHECKBOX_SOLICITUD_ADICIONAL, action: action });
    }
}

export function selectCombo(action, id) {
    LogHelper.In(selectCombo.name, action, id);
    return (dispatch) => {
        dispatch({ type: SELECT_COMBO_SOLICITUD_ADICIONAL, action: action, id: id });
    }
}

export function changeInput(action, value) {
    LogHelper.In(changeInput.name, action, value);

    
    return (dispatch) => {
        dispatch({ type: CHANGE_INPUT_N_S_ADICIONAL, action: action, value: value });
    }
}

export function guardarAdicionalCuentaExistente(data){
    LogHelper.In(guardarAdicionalCuentaExistente.name)
    return (dispatch, getState) => {
        let datos = data;

        let tarjetas = JSON.parse(JSON.stringify(getState().tarjetas));
        let eliminados = JSON.parse(JSON.stringify(getState().nuevaSolicitudAdicional));
        eliminados = eliminados.adicionalesEliminados ?  eliminados.adicionalesEliminados : [];

                
        datos.esCuentaExistente = true;
        data.administradoraId = tarjetas.administradora.Id;
        data.tipoEmpresa = tarjetas.tipoEmpresa;
        data.cliente = tarjetas.clienteResultadoBusqueda;
        data.empresa = tarjetas.empresaVisaSeleccionada && tarjetas.empresaVisaSeleccionada.Id ? tarjetas.empresaVisaSeleccionada : null;
        data.Empresa = tarjetas.empresaVisaSeleccionada ? _tarjetas.empresaVisaSeleccionada.Id : null ;

        if(tarjetas.esModificacion){
            data.SolicitudId = tarjetas.solicitudCuenta.SolicitudId;
            data.CuentaTarjetaId = tarjetas.datosSolicitud.CuentaTarjetaId;  
            data.DatosSolicitud = tarjetas.datosSolicitud;
            data.DatosSolicitud.Comunicacion = [];
            data.SolicitudCuenta = tarjetas.solicitudCuenta;
            data.parcialmenteAceptada = tarjetas.cuentaParcialmenteAceptada;
            data.modificaTitular = tarjetas.cuentaParcialmenteAceptada && tarjetas.cuentasAdicionales.some(t=>t.EsAdicional== "0" && t.TarjetaCreditoEstadoId == 1)
            data.adicionalesEliminados = eliminados

            if (data.SolicitudId == null)
                SolicitudManager.NuevaSolicitudAdicionales(datos, SagasHelper.GetSagasId, ejecutarPorEstado, _executionContext);
            else
                SolicitudManager.ModificarSolicitudAdicionales(datos, SagasHelper.GetSagasId, ejecutarPorEstado, _executionContext);
        }else{
            SolicitudManager.GuardarSolicitud(datos, SagasHelper.GetSagasId, ejecutarPorEstado, _executionContext);
        }
        _dispatch({ type: READY_REQUEST_CUENTA_ADIC });
    }
}

export function showPopUpCancelAdic() {
    $("#confirmCancelationAdicional").modal('toggle');
}

export function closePopUp() {
    $("#confirmCancelationAdicional").modal('toggle');
}

/**
 *
 */
export function routeToVistaCliente() {
    LogHelper.In(routeToVistaCliente.name);

    return (dispatch, getState) => {
        dispatch({ type: ROUTE_TO_VISTACLIENTE_FROM_ADICIONAL });
    }
}

/**
 *
 */
export function routeToNuevaSolicitudCuenta() {
    LogHelper.In(routeToNuevaSolicitudCuenta.name);

    return (dispatch, getState) => {
        dispatch({type:VOLVER_A_SOLICITUD, payload:true})
        dispatch({ type: ROUTE_TO_CUENTA_FROM_ADICIONAL });
    }
}

export function validateCuenta(adicional) {
    LogHelper.In(validateCuenta.name, adicional);
    
    return (dispatch, getState) => {
        _dispatch = dispatch;
        let nuevaSolicitudCuenta = getState().tarjetas.solicitudCuenta;
        let nuevaSolicitudAdicional = getState().nuevaSolicitudAdicional
        let tipoEmpresa = getState().tarjetas.tipoEmpresa
        _validateAddAdicional(nuevaSolicitudCuenta, nuevaSolicitudAdicional, tipoEmpresa, adicional);
    }
}

export function cancelarAdicional(solicitudCuenta) {
    LogHelper.In(cancelarAdicional.name);
    
    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: CANCELAR_ADICIONAL,solicitudCuenta });
    }
}

export function hidePopUp() {
    LogHelper.In(hidePopUp.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ESCONDER_POPUP_ADICIONAL });
    }
}

export function guardarBorrador() {
    LogHelper.In(guardarBorrador.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = getState();
        let data = state.nuevaSolicitudCuenta;
        data.administradoraId = _tarjetas.administradora.Id;
        data.tipoEmpresa = _tarjetas.tipoEmpresa;
        data.cliente = state.tarjetas.clienteResultadoBusqueda;

        SolicitudManager.GuardarSolicitudBorrador(data, redirectVistaCliente);
    }
}

function redirectVistaCliente() {
    _dispatch({ type: REDIRECT_VISTA_CLIENTE_FROM_ADICIONAL });
}

export function stopRedirectVistaCliente() {
    LogHelper.In(stopRedirectVistaCliente.name);

    return (dispatch) => {
        dispatch({ type: STOP_REDIRECT_VISTA_CLIENTE_FROM_ADICIONAL });
    }
}


export function edicionClienteAdicional(idAdicional){
    //al seleccionar editar adicional, carga los datos de este adicional para mostrarlos 
    logHelper.In(edicionClienteAdicional.name, idAdicional)
    return(dispatch , getState)=>{
        let adicionales = getState().nuevaSolicitudAdicional.cuentasAdicionales;
        let clienteSeleccionado = {};
        adicionales.map(adicional=>{
            if(adicional.idAdicional ==idAdicional ) clienteSeleccionado = adicional
        })
        dispatch({type:EDITAR_CLIENTE_ADICIONAL, id:idAdicional, adicionales:adicionales})
        dispatch({ type: CARGAR_CLIENTE_PARA_TARJETA, payload:clienteSeleccionado.ClienteTarjetas });
    }
}
export function borrarClienteAdicional(idAdicional){
    //borra un adicional seleccionado
    logHelper.In(borrarClienteAdicional.name, idAdicional)
    return(dispatch, getState)=>{
        
        let nuevaSolicitudAdicional = getState().nuevaSolicitudAdicional
        let adicionalEliminado;
        dispatch({type:ELIMINAR_CLIENTE_ADICIONAL, id:idAdicional, nuevaSolicitudAdicional:nuevaSolicitudAdicional})
        if(_tarjetas.esModificacion){
                nuevaSolicitudAdicional.cuentasAdicionales.map(adic=>{
                    if(adic.idAdicional == idAdicional){
                        adicionalEliminado = JSON.parse(JSON.stringify(adic))
                        adicionalEliminado.Delete=true
                    } 
                })
                dispatch({type:ELIMINAR_CLIENTE_ADICIONAL_TARJETAS, adicionalEliminado})
        }
    }

}
export function mostrarDatosTitular(){
    logHelper.In(mostrarDatosTitular.name)
    let sc= _tarjetas.solicitudCuenta
    return(dispatch)=>{
        dispatch({type:MOSTRAR_DATOS_TITULAR, solicitudCuenta:sc })
    }
    }



/**
 * 
 */
export function volverASolicitud(payload){

    logHelper.In(volverASolicitud.name)

    return(dispatch, getState)=>{

        dispatch({type:VOLVER_A_SOLICITUD, payload})
    }
}

export function cleanStore(){
    logHelper.In(cleanStore.name)

    return(dispatch, getState)=>{

        dispatch({type:CLEAN_STORE})
    }

}



/*---------------------------------------------- FUNCIONES AUXILIARES ----------------------------------------------*/

/*LLAMAR A ESTA FUNCION ANTES DE HACER EL GUARDADO*/
function _validateAddAdicional(nuevaSolicitudCuenta, nuevaSolicitudAdicional, tipoEmpresa, adicional) {
    LogHelper.In(_validateAddAdicional.name, nuevaSolicitudCuenta, nuevaSolicitudAdicional, tipoEmpresa, adicional);
    
    let marca = nuevaSolicitudCuenta.productoVisaSeleccionado ? 1 : 2
    let fieldsToValidate;
    let data = nuevaSolicitudAdicional;
    let dataCuenta = nuevaSolicitudCuenta;
    let dataEmpresa = tipoEmpresa;
    let productoVisa =dataCuenta.productoVisaSeleccionado;
    switch (marca) {
        case 1:
            fieldsToValidate = [
                { type: "denominacion", valid: "seleccionoDenominacionAdicional", hasCondition: true },/* ok  */
                { type: "ATLAS_DISTRIBUCION", valid: "seleccionoDistribucion", hasCondition: true },/* ok  */
                { type: "denominacionCuartaLinea", valid: "seleccionoDenominacionCuartaLinea", hasCondition: true },/* ok  */
                { type: "tipoVigencia", valid: "seleccionoTipoVigencia", hasCondition: true },
                { type: "HabilitacionCajeros", valid: "seleccionoHabilitacionCajeros", hasCondition: true },/* ok  */
                { type: "limites", valid: "seleccionoLimites", hasCondition: true },
                { type: "centroCostos", valid: "seleccionoCentroCostos", hasCondition: true },
                { type: "costoEmision", valid: "seleccionoCostoEmision", hasCondition: true },/* ok  */
                { type: "cuotasEmision", valid: "seleccionoCuotasEmision",hasCondition:true},
                { type: "limiteTransaccion", valid: "seleccionoLimiteTransaccion",hasCondition:true}
                //{ type: "limiteCompra", valid: "seleccionoLimiteCompra", hasCondition: true },/* ok  */
            ];
            break;
        case 2:
            fieldsToValidate = [
                { type: "limitesCabal", valid: "seleccionoLimitesCabal", hasCondition: true },
            ];
            break
        default:
    }
    const valids = [];
    
    fieldsToValidate.forEach(f => {
        let result = false;

        if (f.hasCondition) {
            switch (f.type) {
                case "denominacion": {
                    let regExp = new RegExp(/^(?!\s)(?!.*\s{2,})([a-záéíóúñÑA-Z \.]*)(?<!\s)$/);
                    let largo = data.nombreAdicional.length + data.apellidoAdicional.length;

                    if (regExp.test(data.nombreAdicional) && regExp.test(data.apellidoAdicional) && data.nombreAdicional[0] !== "." && data.nombreAdicional !=="" &&  data.apellidoAdicional!=="" && data.apellidoAdicional[0] !=="." && largo < 19) {
                        result = true;
                    }
                    break;
                }
                case "limitesCabal": {

                    let limiteAdicional = (data.LimiteDeCompraClienteAdicionalSeleccionado && data.LimiteDeCompraClienteAdicionalSeleccionado !="") ? parseInt(data.LimiteDeCompraClienteAdicionalSeleccionado) : null;
                    let limiteCuenta = (dataCuenta.limiteCompra && dataCuenta.limiteCompra !="") ? parseInt(dataCuenta.limiteCompra) : 0;

                    if(limiteAdicional && limiteAdicional <= limiteCuenta){
                        result=true;
                    }else{
                        result=false;
                    }
                    break;
                }
                case "ATLAS_DISTRIBUCION": {
                    if(dataEmpresa.EmpresaIndividuos=="I" && productoVisa.UtilizaCodigoDistribucion){
                        if (data.SelectCodigoDistribucionClienteAdicional) {
                            result = true
                        }else {
                            result=false
                        }
                     }else{
                         result = true //cambiar cuando se haga el tipo empresa
                     }
                    break;
                }
                case "denominacionCuartaLinea": {
                    let amount = data.denominacionCuartaLinea ? data.denominacionCuartaLinea.length : "";

                    if (!data.denominacionCuartaLinea || amount <= 19) {
                        result = true;
                    }else{
                        result = false;
                    }
                    break;
                }

                case "tipoVigencia": {
                    if (data.seleccionaTarjetaTemporal) {
                        result = data.vigenciaTemporalId>0
                    }else{
                        result = true
                    }
                    break;
                 }
                case "HabilitacionCajeros": {
                    //si parametria general habilita, validar si esta checkeado 
                    let tipoCliente = adicional.ClienteTarjetas.DatosClientes.TipoPersona;

                    if (dataCuenta.GET_ATLAS_PARAMETRO_GENERAL.SINOREDBANELCO && tipoCliente == "F") {
                        result = !!data.SelectHabilitacionCajeroAdicional
                    }else{
                        result = true
                    }
                    break;
                }
                case "limites":{
                    let limites= dataCuenta.GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID.filter(d=>d.Id==dataCuenta.modeloDistribucionId)[0].CODIGO
                    if(limites!=="SINLIMITE" && data.SeleccionModeloDistribucionLimitesClienteAdicional){
                        /* verifico que todos los valores sean numericos  */

                        let {LimiteDeCompraClienteAdicionalSeleccionado,LimiteDeCompraEnCuotasClienteAdicionalSeleccionado, LimiteDeAdelantosClienteAdicionalSeleccionado}=data

                        let limiteDeCompra=parseFloat(LimiteDeCompraClienteAdicionalSeleccionado)
                        let limiteDeCompraEnCuotas=parseFloat(LimiteDeCompraEnCuotasClienteAdicionalSeleccionado)
                        let limiteDeAdelantos = parseFloat(LimiteDeAdelantosClienteAdicionalSeleccionado)             

                        let arr2 = [LimiteDeCompraClienteAdicionalSeleccionado,LimiteDeCompraEnCuotasClienteAdicionalSeleccionado, LimiteDeAdelantosClienteAdicionalSeleccionado]

                        /*si alguno de los limites, no es un valor numerico con hasta dos decimales errorLimites sera TRUE*/
                        let  errorLimites = false;
                        arr2.map(limite=>{
                            if(!(/^\d{0,2}(\.\d{1,2})?$/.test(limite)) && limite != "100" && limite != "1") errorLimites = true;
                            if(parseFloat(limite) > 100 || parseFloat(limite) <= 0) errorLimites = true;
                            if(limite == "") errorLimites = true;
                        })
                        
                        if(!errorLimites){ //si se ingresaron todos los limites 
                                if(data.SeleccionModeloDistribucionLimitesClienteAdicional == false){
                                    result =true 
                                }else{
                                    if(limites == "LIMUNICO_I" || limites =="LIMUNICO"){
                                        // SI ES LÍMITE ÚNICO SE DEBE VERIFICAR QUE LOS LÍMITES DE TODAS LAS TARJETAS SUMADOS NO EXCEDAN EL 100%
                                        
                                        // PARA VALIDAR SE FILTRA PRIMERO POR EL ID DE ADICIONAL, PARA QUE DE TRATARSE DE UNA MODIFICACIÓN NO SUME EL
                                        // LÍMITE 2 VECES.
                                        let adicionales = dataCuenta.cuentasAdicionales.filter(cuenta=>cuenta.idAdicional != data.idAdicional);
                                        
                                        /* validacion para LimiteUnico */
                                        let limitesCompraAdicionales=0;
                                           
                                        if(adicionales.length > 0){//si hay clientes adicionales sumo los porcentajes asignados  
                                            adicionales.map(a=>{limitesCompraAdicionales += parseFloat(a.LimiteDeCompra)})
                                        }   
    
                                        if(!(limitesCompraAdicionales+limiteDeCompra>100)){
                                            result = true
                                        }
                                    }else{
                                        result =true
                                    }
                                }

                        }else{
                            result = false
                        }
                    }else{
                            result=true
                        }
                
                        break;
                }
                case "limiteTransaccion":{
                    if(data.SeleccionLimiteTransaccionClienteAdicional){
                       if((data.LimitePorTransaccionAdicionalSeleccionado && /^\d{0,2}(\.\d{1,2})?$/.test(data.LimitePorTransaccionAdicionalSeleccionado) || data.LimitePorTransaccionAdicionalSeleccionado == "100" )){
                        result =true
                       }else{
                           result = false
                       }
                    }else{
                        result = true
                    }
                    break
                }
                case "costoEmision": {
                    let bonificacionParcial = true
                    let cantidadCuotas = true
                    if(dataEmpresa.EmpresaIndividuos=="I"){//si se trata de un tipo individuo evaluo los costos de emision 
                        if(productoVisa.CostoEmision!=="SC"){// si el costo de emision es distinto a sin cargo, evaluo cada caso
                            if(productoVisa.CostoEmision=="BP"){//cuando el C.E es BP, valido que se haya ingresado una bonificacion parcial y que cumpla los requisitos
                                bonificacionParcial= (parseInt(data.porcEmision)>= productoVisa.PorcBonificacionEmisionDesde && parseInt(data.porcEmision)<=productoVisa.PorcBonificacionEmisionHasta)
                            }
                            if(productoVisa.CargoEnCuotas){
                                cantidadCuotas= (parseInt(data.cuotasEmision)>= parseInt(productoVisa.CargoEnCuotasDesde) && parseInt(data.cuotasEmision)<= parseInt(productoVisa.CargoEnCuotasHasta))                                                    
                            }
                        }
                    }
                    result =(bonificacionParcial && cantidadCuotas)
                   
                    break;
                }
                case "cuotasEmision": {
                    
                    if(dataEmpresa.EmpresaIndividuos=="I"){//si se trata de un tipo individuo evaluo los costos de emision 
                        if(productoVisa.CostoEmision!=="SC"){// si el costo de emision es distinto a sin cargo, evaluo cada caso
                            if(productoVisa.CargoEnCuotas){
                                result = (parseInt(data.cuotasEmision)>= parseInt(productoVisa.CargoEnCuotasDesde) && parseInt(data.cuotasEmision)<= parseInt(productoVisa.CargoEnCuotasHasta))                                                    
                            }else{
                                result = true
                            }
                        }else{
                            result =  true
                        }
                    }else{
                        result = true
                    }                  
                    break;
                }
                case "centroCostos": {
                    result=true
                    //si la cuenta es empresarial
                    if(dataEmpresa.EmpresaIndividuos=="E"){
                        let codigoSector=parseInt(data.codigoSectorCentroDeCostos)
                        let codigoArea =parseInt(data.codigoAreaCentroDeCostos)
                        if(codigoSector.length>3 || codigoArea.length>3 || !(/^([1-9a-zA-Z]{1,3})$/.test(codigoSector))|| !(/^([1-9a-zA-Z]{1,3})$/.test(codigoArea))){
                            result=false
                        }  
                        else if(!isNaN(codigoSector)){//si se ingreso un codigo de sector la validacion depende de que se haya ingresado un codigo de area
                            result=!isNaN(codigoArea)
                        }
                        }
                        
                    break;
                }
            }
        }else{
            result = !([null, 0, ""].some(s => s === data[f.type]));
        }
        data.ERROR_ADICIONAL[f.valid] = result
        valids.push(result);
    });
    const validate = !valids.some(v => v == false);
    
    if (validate) {
        GuardarClienteAdicional(adicional, data);
        _dispatch({ type: CONFIRMAR_CLIENTE_PARA_TARJETA_ADICIONAL });
        
    //     if (!_tarjetas.esModificacion) {
    //         nuevaSolicitudCuenta.administradoraId = _tarjetas.administradora.Id;
    //         nuevaSolicitudCuenta.tipoEmpresa = _tarjetas.tipoEmpresa;
    //         nuevaSolicitudCuenta.cliente = _tarjetas.clienteResultadoBusqueda;
    //         SolicitudManager.GuardarSolicitud(nuevaSolicitudCuenta, SagasHelper.GetSagasId, ejecutarPorEstado, _executionContext);
    //         _dispatch({ type: READY_REQUEST_ADICIONAL });
    //     } else {
    //         nuevaSolicitudCuenta.administradoraId = _tarjetas.administradora.Id;
    //         nuevaSolicitudCuenta.tipoEmpresa = _tarjetas.tipoEmpresa;
    //         nuevaSolicitudCuenta.cliente = _tarjetas.clienteResultadoBusqueda;
    //         SolicitudManager.ModificarSolicitud(nuevaSolicitudCuenta, SagasHelper.GetSagasId, ejecutarPorEstado, _executionContext);
    //         _dispatch({ type: READY_REQUEST_ADICIONAL });
    //     }
} 
else {    
    _dispatch({ type: VALIDATE_ADICIONAL_ERROR, error: data.ERROR_ADICIONAL });
    }
}
/**
 * 
 * @param {any} data
 */
function _cargarDatosPantalla(data) {
    LogHelper.In(_cargarDatosPantalla.name, data);
    
    userFeatures = JSON.parse(JSON.stringify(data));

    let adminEmpCueTarFunctions = JSON.parse(JSON.stringify(data.ADMINEMPCUETAR));
    let adminEmpCueTarFunctionsAllowed = [];

    let solicitudFunctions = JSON.parse(JSON.stringify(data.SOLICITUD));
    let solicitudFunctionsAllowed = [];

    let permisos = {
        componentes: {
            Pantalla: { Active: false, Locked: false },
            RadioButtons: { Active: false, Locked: false },
            BotonesAnteriorSiguiente: { Active: false, Locked: false },
            BotonNuevaCuenta: { Active: false, Locked: false },
            BotonDistribuirLimites: { Active: false, Locked: false },
            IconoDeOjo: { Active: false, Locked: false },
            BotonGuardarBorrador: { Active: false, Locked: false }
        },
        adminEmpCueTarFunctionsAllowed: {},
        solicitudFunctionsAllowed: {}
    };

    adminEmpCueTarFunctions.forEach(p => { permisos.adminEmpCueTarFunctionsAllowed[p.Codigo_Funcion] = true; });
    solicitudFunctions.forEach(p => { permisos.solicitudFunctionsAllowed[p.Codigo_Funcion] = true; });

    /*if (_tarjetas.esModificacion == true) {/*

        //COMENTADOS PERMISOS, VER AL FINAL


        switch (_tarjetas.estadoSolicitud.toLowerCase()) {
            case "borrador": {
                if (permisos.solicitudFunctionsAllowed.Consulta == true) {
                    permisos.componentes.Pantalla.Active = true
                    permisos.componentes.BotonesAnteriorSiguiente.Active = true;
                    permisos.componentes.IconoDeOjo.Active = true;

                    if (permisos.solicitudFunctionsAllowed.Modificacion == true) {
                        permisos.componentes.RadioButtons.Active = true;
                        permisos.componentes.BotonNuevaCuenta.Active = true;
                        permisos.componentes.BotonDistribuirLimites.Active = true;
                        permisos.componentes.BotonGuardarBorrador.Active = true;
                    } else {
                        if ((permisos.solicitudFunctionsAllowed.Distribucion == true)
                            || (permisos.solicitudFunctionsAllowed.Confirmacion == true)) {
                            permisos.componentes.BotonDistribuirLimites.Active = true;
                        }
                    }
                } else {
                    /*Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que 
                    no será capaz de acceder a la pantalla*/
                    /*permisos.componentes.Pantalla = { Active: false }
                };
                break;
            }
            case "cuenta / tarjeta parcialmente aceptada por adm":
            case "cuenta / tarjeta rechazada por adm":
            case "empresa rechazada por adm":
            case "denegada banco":
            case "completada":
            case "confirmada": {
                if (permisos.solicitudFunctionsAllowed.Consulta == true) {
                    permisos.componentes.Pantalla.Active = true
                    permisos.componentes.BotonesAnteriorSiguiente.Active = true;
                    permisos.componentes.IconoDeOjo.Active = true;
                    permisos.componentes.BotonDistribuirLimites.Active = true;

                    let completadaResult = _tarjetas.estadoSolicitud.toLowerCase() == "completada"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    let confirmadaResult = _tarjetas.estadoSolicitud.toLowerCase() == "confirmada"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    let denegadaResult = _tarjetas.estadoSolicitud.toLowerCase() == "denegada banco"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    let ctpResult = _tarjetas.estadoSolicitud.toLowerCase() == "cuenta / tarjeta parcialmente aceptada por adm"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    let ctrResult = _tarjetas.estadoSolicitud.toLowerCase() == "cuenta / tarjeta rechazada por adm"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    let erResult = _tarjetas.estadoSolicitud.toLowerCase() == "empresa rechazada por adm"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    if (completadaResult || confirmadaResult || denegadaResult || ctpResult || ctrResult || erResult) {
                        permisos.componentes.RadioButtons.Active = true;
                        permisos.componentes.BotonNuevaCuenta.Active = true;
                        permisos.componentes.BotonGuardarBorrador.Active = true;
                    }
                } else {
                    /*Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que 
                    no será capaz de acceder a la pantalla*/
                   /* permisos.componentes.Pantalla = { Active: false }
                };
                break;
            }
            case "enviada": {
                if (permisos.solicitudFunctionsAllowed.Consulta == true) {
                    permisos.componentes.Pantalla.Active = true
                    permisos.componentes.BotonesAnteriorSiguiente.Active = true;
                    permisos.componentes.IconoDeOjo.Active = true;

                    permisos.componentes.BotonDistribuirLimites = { Active: true, Locked: true };
                    permisos.componentes.RadioButtons = { Active: true, Locked: true };
                    permisos.componentes.BotonNuevaCuenta = { Active: true, Locked: true };
                    permisos.componentes.BotonGuardarBorrador = { Active: true, Locked: true };
                } else {
                    /*Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que 
                    no será capaz de acceder a la pantalla*/
                   /* permisos.componentes.Pantalla = { Active: false }
                };
                break;
            }
            default: {
                break;
            }
        }
    */
   //} else {
        if (permisos.adminEmpCueTarFunctionsAllowed.Alta == true) {
            permisos.componentes.Pantalla.Active = true;
            permisos.componentes.RadioButtons.Active = true;
            permisos.componentes.BotonNuevaCuenta.Active = true;
            permisos.componentes.BotonGuardarBorrador.Active = true;

            if (permisos.solicitudFunctionsAllowed.Consulta == true) {
                permisos.componentes.BotonesAnteriorSiguiente.Active = true;
                permisos.componentes.IconoDeOjo.Active = true;
            }
            if (permisos.solicitudFunctionsAllowed.Distribucion == true) {
                permisos.componentes.BotonDistribuirLimites.Active = true;
            }
        } else {
            /*Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que no
            será capaz de acceder a la pantalla*/
            permisos.componentes.Pantalla.Active = false;
        }
    //}

    if (permisos.componentes.Pantalla.Active == true) {
        let param;
        //let cuit = _tarjetas.cliente.Cuit;
        let admId = _tarjetas.administradora.Id;
        let tipoCuentaId = 1//_tipoEmpresa.Id
        //if (!isNaN(cuit)) {
        //    param = { "CUIT": cuit }
        //} else {
        //    if (cuit.indexOf("-") > -1) {
        //        param = { "CUIT": parseInt(cuit.split("-").join("")) }
        //    } else {
        //        param = { "CUIT": parseInt(cuit) }
        //    }
        //}
        
        const localValue = {
            'MARCA': admId,
            'TIPO_CUENTA': tipoCuentaId
        }
        const producto = {
            'PRODUCTO_ID': 1
        }

        //GET_SOLICITUD_CUENTA_1
        LogHelper.Out(_cargarDatosPantalla.name, localValue, 'GET_SOLICITUD_CUENTA_VISA_1', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_SOLICITUD_CUENTA_VISA_1', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');

        //GET_SOLICITUD_CUENTA_2
        //LogHelper.Out(_cargarDatosPantalla.name, null, 'GET_SOLICITUD_CUENTA_2', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        //Engine1Proxy.AddDataSourcesRequests(null, 'GET_SOLICITUD_CUENTA_2', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');

        //GET_SOLICITUD_CUENTA_3
        LogHelper.Out(_cargarDatosPantalla.name, producto, 'GET_SOLICITUD_CUENTA_VISA_3', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(producto, 'GET_SOLICITUD_CUENTA_VISA_3', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
       
        //GET_ATLAS_VIGENCIA_TARJETAS_TEMPORALES
        LogHelper.Out(_cargarDatosPantalla.name, null, 'GET_ATLAS_VIGENCIA_TARJETAS_TEMPORALES', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_ATLAS_VIGENCIA_TARJETAS_TEMPORALES', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');

        /* LogHelper.Out(_cargarDatosPantalla.name, param, 'GET_CUENTA_TARJETA_INFO_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
         Engine1Proxy.AddDataSourcesRequests(param, 'GET_CUENTA_TARJETA_INFO_BY_CUIT', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');*/

        param = { 'ADMINISTRADORA_ID': parseInt(admId) };

        LogHelper.Out(_cargarDatosPantalla.name, param, 'GET_CARTERAS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_CARTERAS', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.Execute((data) => _cargarDatosPantallaCallback(data, permisos), null, null, 'SOLICITUD');
    } else {
        //_dispatch({ type: ACTUALIZAR_ESTADO_DISTRIBUCION_CUENTA });
        _dispatch({ type: GET_SCREEN_DATA_ADICIONAL, resultado: permisos });
    }
}

/**
 * 
 * @param {any} data
 * @param {any} permisos
 */
function _cargarDatosPantallaCallback(data, permisos) {
    LogHelper.In(_cargarDatosPantallaCallback.name, data, permisos);

    const getSolicitudCuenta1 = JSON.parse(data.GET_SOLICITUD_CUENTA_VISA_1);
    //const getSolicitudCuenta2 = JSON.parse(data.GET_SOLICITUD_CUENTA_VISA_2);
    const getSolicitudCuenta3 = JSON.parse(data.GET_SOLICITUD_CUENTA_VISA_3);
    const getVigenciaTarjetasTemporales = JSON.parse(data.GET_ATLAS_VIGENCIA_TARJETAS_TEMPORALES).Recordset0.Rows;
    
    let resultado = {
        'ATLAS_VIGENCIA_TARJETAS_TEMPORALES': getVigenciaTarjetasTemporales,
        'carteras': JSON.parse(data.GET_CARTERAS).Recordset0.Rows,
        //'sucursales': JSON.parse(data.GET_SUCURSAL).Recordset0.Rows,
        'permisos': permisos,
        'cuentas': [],
        'empresaSeleccionada': [],//_tarjetas.empresas.find((empresa) => { return empresa.seleccionada == true }),
        // 'cuentasInfo': JSON.parse(data.GET_CUENTA_TARJETA_INFO_BY_CUIT).Recordset0.Rows,
        'ATLAS_SUCURSALES': getSolicitudCuenta1.Recordset0.Rows,
        'PRODUCTO': getSolicitudCuenta1.Recordset1.Rows,
        'ATLAS_TIPO_CUENTA': getSolicitudCuenta1.Recordset2.Rows,
        'ATLAS_GRUPO_AFINIDAD': getSolicitudCuenta1.Recordset3.Rows,
        'ATLAS_DISTRIBUCION': getSolicitudCuenta1.Recordset4.Rows,
        'ATLAS_COMERCIALIZADORA': getSolicitudCuenta1.Recordset5.Rows,
        'ATLAS_PROMOTOR': getSolicitudCuenta1.Recordset6.Rows,
        'PRODUCTO_DEFAULT_VISA_1': _tarjetas.solicitudCuenta.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO,
        //'ATLAS_CODIGO_GEOGRAFICO': getSolicitudCuenta2.Recordset0.Rows,
        // 'ATLAS_TIPO_COMUNICACION': getSolicitudCuenta2.Recordset1.Rows,
        'PRODUCTO_VISA': /*getSolicitudCuenta3.Recordset0.Rows*/ _tarjetas.solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID,
        'PRODUCTO_DEFAULT_VISA_2': getSolicitudCuenta3.Recordset1.Rows,
        'TARJETAS':_tarjetas.solicitudCuenta,
    };
    _dispatch({ type: GET_SCREEN_DATA_ADICIONAL, resultado, idSolicitud:/* _tarjetas.id*/0 });
}

function ejecutarPorEstado(result, disconectCallback) {
    LogHelper.In(ejecutarPorEstado.name, result, disconectCallback);

    let type;
    let modalId;


    switch (result.Estado) {
        case 2:
            _dispatch({ type: REDIRECT_VISTA_CLIENTE_FROM_ADICIONAL });
            modalId = "solicitudGuardada";
            break;
        case 3:
            HandleErrorSaga();
            break;
        case 5:
            HandleErrorSaga();
            break;
        default:
            HandleErrorSaga();
            break;
    }
    $("#" + modalId).modal();
    disconectCallback();
}

function HandleErrorSaga() {
    let message = {
        value: "Hubo un error al procesar la transacci\u00F3n.",
        class: "error"
    };

    _dispatch({ type: SHOW_SAVE_STATUS_NUEVA_SOLICITUD_CUENTA_ADICIONAL, message });
}
function GuardarClienteAdicional(adicional, nuevaSolicitudAdicional) {
    LogHelper.In(GuardarClienteAdicional.name, adicional, nuevaSolicitudAdicional);
    //guarda los clientes adicionales en tarjetas y NSA, filtra si es caso de un nuevo adicional o una edicion
    let solicitudCuenta= _tarjetas.solicitudCuenta
      
        _dispatch({ type: GUARDAR_CLIENTE_ADICIONAL, value: adicional, solicitudCuenta:solicitudCuenta });
        _dispatch({ type: GUARDAR_SOLICITUD_CUENTA_ADICIONAL, value: adicional, nuevaSolicitudAdicional:nuevaSolicitudAdicional });

 
}





// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/NuevaSolicitudAdicional/actions/NuevaSolicitudAdicionalActions.js